<template>
  <div class="tabs-wrap">
    <div
      v-for="(item, index) in tabData"
      :key="'tabs' + index"
      :class="
        currentClick == item.value ? 'active-tab-class tab-class' : 'tab-class'
      "
      @click="tabClick(item.value)"
    >
      <span>{{ item.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    tabData: {
      type: Array,
    },
  },
  data() {
    return {
      currentClick: this.tabData[0].value,
    };
  },
  created() {},
  computed: {},
  watch: {},
  methods: {
    tabClick(value) {
      this.currentClick = value;
      this.$emit("tabChange", value);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/_handle.scss";
.tab-class.active-tab-class {
  color: #ffcc55;
  background: #303030;
}
.tab-class {
  cursor: pointer;
  height: 32px;
  padding: 0 23px;
  color: rgba(255, 255, 255, 0.65);
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 16px;
  line-height: 32px;
  margin-right: 16px;
}
.tab-class:last-child {
  margin-right: 0;
}
.tabs-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
